var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicLayout',[_c('el-row',[_c('el-col',{attrs:{"xs":{span: 24, offset: 0},"sm":{span: 22, offset: 1},"md":{span: 20, offset: 2},"lg":{span: 18, offset: 3}}},[_c('stats')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }